import { schema } from 'normalizr';

const entitySchema = new schema.Entity('notification', undefined, { idAttribute: 'id' });

export default entitySchema;